<template>
    <el-date-picker
        v-model="dates"
        type="daterange"
        unlink-panels
        range-separator="To"
        :start-placeholder="start_placeholder"
        end-placeholder="End date"
        popper-class="wml-date-picker-popup"
        :size="default"
        :shortcuts="shortcuts"
        value-format="YYYY-M-D"
        :default-value="default_dates"
        @change="updateResult"
      />
</template>

<script setup>
    import {ref} from "vue";
    import { useMailLogStore } from "../stores/maillog";
    import { storeToRefs } from "pinia";
    import moment from 'moment';

    
    const store = useMailLogStore();

    const { dates } = storeToRefs(store);

    const shortcuts = [
    {
      text: 'Today',
      value: () => {
        const start = moment();
        const end = moment();
        return [start, end]
      },
    },
    {
      text: 'Yesterday',
      value: () => {
        const start = moment().subtract(1, 'day');
        const end = moment().subtract(1, 'day');
        return [start, end]
      },
    },
    {
      text: 'This Week',
      value: () => {
        const start = moment().startOf('isoWeek');
        const end = moment().endOf('isoWeek');
        return [start, end]
      },
    },
    {
      text: 'Last Week',
      value: () => {
        const start = moment().startOf('isoWeek').subtract(1, 'week');
        const end = moment().endOf('isoWeek').subtract(1, 'week');

        return [start, end]
      },
    },
    {
      text: 'Last 30 Days',
      value: () => {
        const start = moment().subtract(29, 'days');
        const end = moment();

        return [start, end]
      },
    },
    {
      text: 'This month',
      value: () => {
        const start = moment().startOf('month');
        const end = moment().endOf('month');

        return [start, end]
      },
    },
    {
      text: 'Last month',
      value: () => {
        const start = moment().subtract(1, 'month').startOf('month');
        const end = moment().subtract(1, 'month').endOf('month');

        return [start, end]
      },
    },
    {
      text: 'This Quarter',
      value: () => {
        const start = moment().startOf('quarter');
        const end = moment().endOf('quarter');

        return [start, end]
      },
    },
    {
      text: 'Last Quarter',
      value: () => {
        const start = moment().quarter(moment().quarter() - 1).startOf('quarter');
        const end = moment().quarter(moment().quarter() - 1).endOf('quarter');

        return [start, end]
      },
    },
    {
      text: 'This Year',
      value: () => {
        const start = moment().startOf('year');
        const end = moment().endOf('year');

        return [start, end]
      },
    },
    {
      text: 'Last Year',
      value: () => {
        const start = moment().startOf('year').subtract(1, 'year');
        const end = moment().endOf('year').subtract(1, 'year');

        return [start, end]
      },
    },
    {
      text: 'All Time',
      value: () => {
        const end = moment();
        const start = moment('2019-05-29');

        return [start, end]
      },
    },
  ];

  const updateResult = () => { store.fetchLogs() }

</script>
